const brand = process.env.NEXT_PUBLIC_BRAND;

// eslint-disable-next-line import/no-dynamic-require
const fonts = require(`./fonts.${brand}`).default;

export default fonts;
